<template>
  <div class="input-group">
    <input
      v-if="showInput"
      :value="value"
      type="text"
      class="form-control"
      :class="inputSize"
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
    >
    <div class="input-group-append">
      <button ref="uploadBtn" class="btn btn-outline-secondary" :class="buttonSize" type="button">
        Upload
      </button>
    </div>
  </div>
</template>

<script>
  import createUploader from '@/FormWidgets/uploader/main.js';

  export default {
    name: "UrlInputWithUpload",
    inject: ['uploadTokenUrl'],
    inheritAttrs: false,
    props: {
      value: {
        type: String,
        default: ""
      },
      showInput: {
        type: Boolean,
        default: true
      },
      size: {
        // options are "sm" and "lg", 
        // no prop passed results in "md" 
        type: String,
        default: "",
      }
    },
    data() {
      return {
        uppy: null,
        // todo: remove dollar sign version
        tokenUrl: this.uploadTokenUrl || this.$uploadTokenUrl || '/uploadToken?container=public-images'
      }
    },
    computed: {
      inputSize() {
        return this.size ? `input-${this.size}` : '';
      },
      buttonSize() {
        return this.size ? `btn-${this.size}` : '';
      }
    },
    mounted() {
      this.uppy = createUploader(this.$refs.uploadBtn, {
        tokenUrl: this.tokenUrl,
        onSuccessfulUpload: this.onSuccessfulUpload
      });
    },
    beforeDestroy() {
      this.uppy.close();
    },
    methods: {
      onSuccessfulUpload(name, path) {
        // emit path to update input value
        this.$emit('input', path);
        // reset uppy so we can do it again
        this.uppy.reset();
      }
    }
  }
</script>

<style scoped>

</style>
